/*
  Anadir al carrito sin salir de la landing.

  Antes el formulario hacia un envio normal: POST y salto a /cart. Quien queria
  dos colores acababa fuera de la pagina y tenia que volver, buscar el selector y
  repetir. Ahora se anade en sitio, el contador sube y el selector sigue ahi, asi
  que el segundo color son dos clics.

  Sin JavaScript el formulario sigue funcionando como siempre.
*/
(function () {
  'use strict';

  var formularios = document.querySelectorAll('[data-lander-form]');
  if (!formularios.length) return;

  function pintarTotal(n) {
    document.querySelectorAll('[data-carrito-total]').forEach(function (el) {
      el.textContent = n;
    });
    document.querySelectorAll('[data-carrito-enlace]').forEach(function (el) {
      el.hidden = n === 0;
    });
  }

  function avisar(form, texto, esError) {
    var aviso = form.querySelector('[data-aviso]');
    if (!aviso) return;
    aviso.textContent = texto;
    aviso.hidden = false;
    aviso.classList.toggle('is-error', !!esError);
  }

  function refrescarTotal() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (r) { return r.json(); })
      .then(function (carrito) { pintarTotal(carrito.item_count); });
  }

  formularios.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var boton = form.querySelector('button[name="add"]');
      if (boton && boton.disabled) return;

      var original = boton ? boton.textContent : '';
      if (boton) {
        boton.disabled = true;
        boton.textContent = form.getAttribute('data-texto-anadiendo') || original;
      }

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) {
          if (!r.ok) throw new Error('no se pudo anadir');
          return r.json();
        })
        .then(function (respuesta) {
          avisar(form, form.getAttribute('data-texto-anadido') || '', false);
          // Se avisa por evento en vez de llamar a fbq aqui: este fichero no
          // tiene por que saber que existe un pixel, ni romperse si se quita.
          document.dispatchEvent(new CustomEvent('lander:anadido', {
            detail: {
              id: respuesta && respuesta.variant_id,
              value: respuesta && respuesta.final_line_price != null
                ? respuesta.final_line_price / 100
                : undefined,
            },
          }));
          return refrescarTotal();
        })
        .catch(function () {
          // Si algo falla, se deja que el navegador haga el envio de siempre:
          // mejor un salto a /cart que un boton que no hace nada.
          form.submit();
        })
        .finally(function () {
          if (boton) {
            boton.disabled = false;
            boton.textContent = original;
          }
        });
    });
  });

  refrescarTotal();
})();
